import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import './Splash.css';

import Splash from '../custom/-APP_TARGET/content/Splash';

import { setSplashLoading } from "../../../actions/index";

let timeout = null;
function SplashWrapper() {
  const enabled = useSelector(state => state.splashState);
  let error = useSelector(state => state.error);
  const [visible, setVisible] = useState(true);
  const dispatch = useDispatch();

  const hasProtection = (window.location.origin.includes('labs.beatport.com') && !localStorage.getItem('ns6yT9jb'));
  const callbackAfterProctection = () => {
    localStorage.setItem('ns6yT9jb', Date.now())
    setVisible(false);
    (window['window_resize']) && window['window_resize']();
  }

  useEffect(() => {
    if (!hasProtection) {
      if (!enabled && !error) {
        dispatch(setSplashLoading(100));
        timeout = setTimeout(() => {
          setVisible(false);
          (window['window_resize']) && window['window_resize']();
        }, 1600); // Transition CSS 1.5s
      } else if (!enabled && error && error.message.includes('403')) {
        setVisible(false);
        (window['window_resize']) && window['window_resize']();
      } else {
        (window['window_resize']) && window['window_resize']();
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      }
    }
  }, [enabled, dispatch, error, hasProtection])

  return (Config.HAS_SPLASH && visible) ? <Splash error={error} hasProtection={hasProtection} callback={callbackAfterProctection} /> : null
}

export default SplashWrapper;
